import { render, staticRenderFns } from "./my-status-badge.vue?vue&type=template&id=10ffcab5&"
import script from "./my-status-badge.vue?vue&type=script&lang=js&"
export * from "./my-status-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports